import { Result } from '../../../types';
import React from 'react';
import * as Yup from 'yup';

export const formValidator = Yup.object({
  hasInsurance: Yup.string().required('Required').typeError(''),
  healthInsuranceType: Yup.string().when('hasInsurance', {
    is: 'Yes',
    then: Yup.string().required('Required'),
  }),
});

export interface Recommendation {
  [value: string]: Result;
}
export const recommendationData: Recommendation = {
  Affordable_SpousalCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-out
      </div>
    ),
    subTitle:
      'Because you are covered by a spouse’s health insurance plan, you have two options. We recommend that you opt-out, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-out',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because you are already covered by a spouse’s health insurance plan, you
        do not need an individual health insurance policy so you can opt-out.
      </div>
    ),
    option2Title: 'Option 2: Opt-in',
    option2Description: (
      <div>
        You may wish to opt-in and become “double-covered” by both your spouse’s
        insurance and by an individual coverage plan.
        <br />
        If you choose to opt-in, you do not need to become “double-covered”. If
        you wish, you can choose to be removed from your spouse’s insurance plan
        mid-year, though it is not necessary.
      </div>
    ),
    note: (
      <div>
        <i>
          Note: if your ICHRA benefit allows you a significant allowance that
          would enable you to purchase premium benefits, you may want to
          consider opting-in.
        </i>
      </div>
    ),
  },
  Unaffordable_SpousalCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-out
      </div>
    ),
    subTitle:
      'Because you are covered by a spouse’s health insurance plan, you have two options. We recommend that you opt-out, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-out',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because you are already covered by a spouse’s health insurance plan, you
        do not need an individual health insurance policy so you can opt-out.
      </div>
    ),
    option2Title: 'Option 2: Opt-in',
    option2Description: (
      <div>
        You may wish to opt-in and become “double-covered” by both your spouse’s
        insurance and by an individual coverage plan.
        <br />
        If you choose to opt-in, you do not need to become “double-covered”. If
        you wish, you can choose to be removed from your spouse’s insurance plan
        mid-year, though it is not necessary.
      </div>
    ),
    note: '',
  },
  Affordable_ParentalCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-out
      </div>
    ),
    subTitle:
      'Because you are covered by a parent’s health insurance plan, you have two options. We recommend that you opt-out, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-out',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because you are already covered by a parent’s health insurance plan, you
        do not need an individual health insurance policy so you can opt-out.
      </div>
    ),
    option2Title: 'Option 2: Opt-in',
    option2Description: (
      <div>
        You may wish to opt-in and become “double-covered” by both your parent’s
        insurance and by an individual coverage plan.
        <br />
        If you choose to opt-in, you do not need to become “double-covered”. If
        you wish, you can choose to be removed from your parent’s insurance plan
        mid-year, though it is not necessary.
      </div>
    ),
    note: (
      <div>
        <i>
          Note: if your ICHRA benefit allows you a significant allowance that
          would enable you to purchase premium benefits, you may want to
          consider opting-in.
        </i>
      </div>
    ),
  },
  Unaffordable_ParentalCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-out
      </div>
    ),
    subTitle:
      'Because you are covered by a parent’s health insurance plan, you have two options. We recommend that you opt-out, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-out',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because you are already covered by a parent’s health insurance plan, you
        do not need an individual health insurance policy so you can opt-out.
      </div>
    ),
    option2Title: 'Option 2: Opt-in',
    option2Description: (
      <div>
        You may wish to opt-in and become “double-covered” by both your parent’s
        insurance and by an individual coverage plan.
        <br />
        If you choose to opt-in, you do not need to become “double-covered”. If
        you wish, you can choose to be removed from your parent’s insurance plan
        mid-year, though it is not necessary.
      </div>
    ),
    note: '',
  },
  Affordable_IndividualCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you are covered by an individual health insurance plan, you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because you are currently covered by an individual health insurance plan
        this benefit is a great fit!
        <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for your health expenses!
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you do not wish to receive a monthly reimbursement allowance or if you prefer to obtain health coverage elsewhere, it might make sense to opt-out.',
    note: (
      <div>
        <i>
          Note: if you are currently receiving premium tax credits (PTCs) that
          subsidize the cost of your individual health insurance premium, this
          ICHRA benefit changes a few things. Because your allowance is
          affordable, that means that any PTCs you receive now, you will have to
          forfeit. Additionally, even if you opt-out of this benefit, you may
          not still use your PTCs <b>because</b> you are being given an
          affordable allowance.{' '}
          <a
            href="https://www.peoplekeep.com/blog/the-ichra-and-premium-tax-credits-what-are-the-rules"
            target="_blank"
          >
            Click here to learn more!
          </a>
        </i>
      </div>
    ),
  },
  Unaffordable_IndividualCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Consider your options
      </div>
    ),
    subTitle: (
      <div>
        Because your allowance is considered unaffordable, you have two options
        listed below. We advise that you carefully consider your options. It may
        also be important for you to know if you are eligible for premium tax
        credits (PTCs) according to your income and family status.
        <a href="https://www.healthcare.gov/lower-costs/" target="_blank">
          {' '}
          Do I qualify for tax credits?{' '}
        </a>
      </div>
    ),
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        If you are not eligible for premium tax credits (PTCs), or your
        allowance is higher than the tax credits available to you, your best
        decision is to opt-in and get reimbursed for your insurance premium from
        your employer!
        <br />
        <br />
        Keep in mind, if you opt-in, you will not be able to access your PTCs.
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description: (
      <div>
        If you are eligible for premium tax credits and the tax credits give you
        more money than your allowance, you should opt-out and take the tax
        credits. You may not use both, unfortunately.
      </div>
    ),
    note: '',
  },
  Affordable_ShortTermCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you are covered by a short term health insurance you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because a short term insurance plan is not an eligible plan under ICHRA,
        you must obtain an individual health insurance plan that is considered
        minimum essential coverage if you wish to participate. If you need help
        navigating insurance options, reach out to our partners at{' '}
        <a
          target="_blank"
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
        >
          KindHealth
        </a>
        .
        <br /> <br />
        Why opt-in? <br /> <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for certain health expenses!
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you do not wish to receive a monthly reimbursement allowance and you wish to keep your existing plan, it might make sense to opt-out.',
    note: '',
  },
  Unaffordable_ShortTermCoverage: {
    title: (
      <div>
        <b>Our recommendation: </b>Consider your options
      </div>
    ),
    subTitle: (
      <div>
        Because your allowance is considered unaffordable, you have two options
        listed below. We advise that you carefully consider your options. It may
        also be important for you to know if you are eligible for premium tax
        credits (PTCs) according to your income and family status.
        <a href="https://www.healthcare.gov/lower-costs/" target="_blank">
          {' '}
          Do I qualify for tax credits?
        </a>
      </div>
    ),
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        If you are not eligible for premium tax credits (PTCs), or your
        allowance is higher than the tax credits available to you, your best
        decision is to opt-in and get reimbursed for your insurance premium from
        your employer! <br />
        In order to use your ICHRA allowance, you must have an individual
        coverage health insurance policy. <br /> Because a short term insurance
        plan is not an eligible plan under ICHRA, you must obtain an individual
        health insurance plan that is considered minimum essential coverage if
        you wish to participate. If you need help navigating insurance options,
        reach out to our partners at{' '}
        <a
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
          target="_blank"
        >
          KindHealth
        </a>
        . <br />
        <br /> Keep in mind, if you opt-in, you will not be able to access your
        PTCs.
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description: (
      <div>
        If you are eligible for premium tax credits and the tax credits give you
        more money than your allowance, you should opt-out and take the tax
        credits. You may not use both, unfortunately.
      </div>
    ),
    note: '',
  },
  Affordable_Medicare: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you are covered by Medicare, you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy, which includes Medicare.
        <br />
        Because you are currently covered by an individual health insurance plan
        this benefit is a great fit!
        <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for certain health expenses!
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you do not wish to receive a monthly reimbursement allowance or if you prefer to obtain health coverage elsewhere, it might make sense to opt-out.',
    note: '',
  },
  Unaffordable_Medicare: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you are covered by Medicare, you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy, which includes Medicare.
        <br />
        Because you are currently covered by an individual health insurance plan
        this benefit is a great fit!
        <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for certain health expenses!
        <br />
        <br />
        Even though your allowance is unaffordable, it’s likely your allowance
        will still cover a portion of your supplemental insurance premiums which
        is why we recommend you opt-in.
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you do not wish to receive a monthly reimbursement allowance or if you prefer to obtain health coverage elsewhere, it might make sense to opt-out. ',
    note: '',
  },
  Affordable_Medicaid: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you are covered by Medicaid, you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because Medicaid is not an eligible plan under ICHRA, you must obtain an
        individual health insurance plan that is considered minimum essential
        coverage if you wish to participate. If you need help navigating
        insurance options, reach out to our partners at{' '}
        <a
          target="_blank"
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
        >
          KindHealth
        </a>
        .<br />
        <br />
        Why opt-in?
        <br />
        <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for certain health expenses!
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you do not wish to receive a monthly reimbursement allowance or you plan to seek health coverage elsewhere, it might make sense to opt-out.',
    note: '',
  },
  Unaffordable_Medicaid: {
    title: (
      <div>
        <b>Our recommendation: </b>Consider your options
      </div>
    ),
    subTitle: (
      <div>
        Because your allowance is considered unaffordable, you have two options
        listed below. We advise that you carefully consider your options. It may
        also be important for you to know if you are eligible for premium tax
        credits (PTCs) according to your income and family status.
        <a target="_blank" href="https://www.healthcare.gov/lower-costs/">
          {' '}
          Do I qualify for tax credits?
        </a>
      </div>
    ),
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because a Medicaid is not an eligible plan under ICHRA, you must obtain
        an individual health insurance plan that is considered minimum essential
        coverage if you wish to participate. If you need help navigating
        insurance options, reach out to our partners at{' '}
        <a
          target="_blank"
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
        >
          KindHealth
        </a>
        .
        <br />
        <br />
        Keep in mind, if you opt-in, you will not be able to access your PTCs.
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description: (
      <div>
        If you are eligible for premium tax credits and the tax credits give you
        more money than your allowance, you should opt-out and take the tax
        credits. You may not use both, unfortunately.
        <br />
        You may also choose to opt-out if you do not wish to receive a monthly
        reimbursement allowance and you wish to keep your existing plan.
      </div>
    ),
    note: '',
  },
  Affordable_HealthSharing: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you are covered by a health sharing plan you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision.',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because a health sharing plan is not an eligible plan under ICHRA, you
        must obtain an individual health insurance plan that is considered
        minimum essential coverage if you wish to participate. If you need help
        navigating insurance options, reach out to our partners at{' '}
        <a
          target="_blank"
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
        >
          KindHealth
        </a>
        .
        <br />
        <br />
        Why opt-in?
        <br />
        <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for certain health expenses!
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you do not wish to receive a monthly reimbursement allowance and you wish to keep your existing plan, it might make sense to opt-out. ',
    note: '',
  },
  Unaffordable_HealthSharing: {
    title: (
      <div>
        <b>Our recommendation: </b>Consider your options
      </div>
    ),
    subTitle: (
      <div>
        Because your allowance is considered unaffordable, you have two options
        listed below. We advise that you carefully consider your options. It may
        also be important for you to know if you are eligible for premium tax
        credits (PTCs) according to your income and family status.
        <a target="_blank" href="https://www.healthcare.gov/lower-costs/">
          {' '}
          Do I qualify for tax credits?
        </a>
      </div>
    ),
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because a health sharing plan is not an eligible plan under ICHRA, you
        must obtain an individual health insurance plan that is considered
        minimum essential coverage if you wish to participate. If you need help
        navigating insurance options, reach out to our partners at{' '}
        <a
          target="_blank"
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
        >
          KindHealth
        </a>
        .
        <br />
        <br />
        Keep in mind, if you opt-in, you will not be able to access your PTCs.
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description: (
      <div>
        If you are eligible for premium tax credits and the tax credits give you
        more money than your allowance, you should opt-out and take the tax
        credits. You may not use both, unfortunately.
        <br />
        You may also choose to opt-out if you do not wish to receive a monthly
        reimbursement allowance and you wish to keep your existing plan.
      </div>
    ),
    note: '',
  },
  Affordable_NoHealthInsurance: {
    title: (
      <div>
        <b>Our recommendation: </b>Opt-in
      </div>
    ),
    subTitle:
      'Because you do not have health insurance, you have two options. We recommend that you opt-in, but make sure to read about both options so you make the correct decision',
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        In order to use your ICHRA allowance, you must be on an individual
        coverage health insurance policy.
        <br />
        Because you are currently not covered by health insurance, you must
        obtain an individual health insurance plan that is considered minimum
        essential coverage if you wish to participate. If you need help
        navigating insurance options, reach out to our partners at{' '}
        <a
          target="_blank"
          href="https://peoplekeep.kindhealth.co/health/quote/1/modal-partnership"
        >
          KindHealth
        </a>
        .
        <br />
        <br />
        Why opt-in?
        <br />
        <br />
        If you opt-in, you’ll be able to take advantage of your monthly
        allowance and be reimbursed for certain health expenses!
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      "If you do not wish to receive a monthly reimbursement allowance or don't think you will purchase individual health insurance at all, it might make sense to opt-out.",
    note: '',
  },
  Unaffordable_NoHealthInsurance: {
    title: (
      <div>
        <b>Our recommendation: </b>Consider your options
      </div>
    ),
    subTitle: (
      <div>
        Because your allowance is considered unaffordable, you have two options
        listed below. We advise that you carefully consider your options. It may
        also be important for you to know if you are eligible for premium tax
        credits according to your income and family status.
        <a target="_blank" href="https://www.healthcare.gov/lower-costs/">
          {' '}
          Do I qualify for tax credits?
        </a>
      </div>
    ),
    option1Title: 'Option 1: Opt-in',
    option1Description: (
      <div>
        Because you do not currently have health insurance, it might make sense
        for you to opt-in. If you are not eligible for premium tax credits
        (PTCs), or your allowance is higher than the tax credits available to
        you, your best decision is to opt-in and get reimbursed for your
        insurance premium from your employer!
        <br />
        Keep in mind, if you opt-in, you will not be able to access your PTCs.
      </div>
    ),
    option2Title: 'Option 2: Opt-out',
    option2Description:
      'If you are eligible for premium tax credits and the tax credits give you more money than your allowance, you should opt-out and take the tax credits. You may not use both, unfortunately. ',
    note: '',
  },
};
